export const LocationsPageNumConstants = {
    GET_PAGENUM_REQUEST: 'GET_PAGENUM_REQUEST',
    SET_PAGENUM_SUCCESS: 'SET_PAGENUM_SUCCESS'
};